import Button from '@blocks/Button'
import Grid from '@blocks/Grid'
import { tablet } from '@styles/mixins'
import { colors } from '@styles/vars'
import React from 'react'
import styled, { css } from 'styled-components'
import { useSalonContext } from '../context'

export default function SalonMainScreenAction({ type = "primary" }: Props) {
    const { salon } = useSalonContext()
    const action = salon.attrs.actions()[type]

    if (!action)
        return null

    return (
        <div>
            <Grid gap="10px">
                <Button type={type} to={action.to}>
                    {action.label}
                </Button>
                {action.description && <ActionDescription>{action.description}</ActionDescription>}
            </Grid>
        </div>
    )
}

interface Props {
    type?: "secondary" | "primary"
}

const ActionDescription = styled.small`
    text-align: center;
    color: ${colors.darkGrey};
    a {
        text-decoration: underline;
    }
    ${tablet(css`
        max-width: 220px;
        margin: 0 auto;
    `)}
`